import { combineReducers } from 'redux';
//import defaultReducer from './defaultReducer';
import localEphemeralReducer from './localEphemeralReducer';
import localPersistentReducer from './localPersistentReducer';
import serverSyncedReducer from './serverSyncedReducer';

export default combineReducers({
  //defaultRed: defaultReducer,
  localEphemeral: localEphemeralReducer,
  localPersistent: localPersistentReducer,
  serverSynced: serverSyncedReducer,
});
